import templateUrl from './shiftFeedbackTableComponent.html';

export default {
  bindings: {
    data: '<',
    schema: '<',
    orderBy: '<',
    canDataColumnBeVisible: '<',
    getDataForExport: '=?',
    filtersOpened: '<',
    saveColumns: '&',
    reportColumns: '<',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './shiftFeedbackTableComponentCtrl')).default,
  templateUrl,
};
